function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeWidth: 2
}, React.createElement("circle", {
  cx: 25.5,
  cy: 25.5,
  r: 24.5
}), React.createElement("path", {
  d: "M42.59 44.545l24.82 22.91",
  strokeLinecap: "square"
}));

var SvgIconSearch = function SvgIconSearch(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 69 69"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjkgNjkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIj48Y2lyY2xlIGN4PSIyNS41IiBjeT0iMjUuNSIgcj0iMjQuNSIvPjxwYXRoIGQ9Im00Mi41OTA5MDkgNDQuNTQ1NDU1IDI0LjgxODE4MiAyMi45MDkwOSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPjwvZz48L3N2Zz4K";
export { SvgIconSearch as ReactComponent };